export const makeArray = (defaultValue: string, length: number) =>
  Array.from({ length }, () => defaultValue as string);
